module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic14.b05398b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic14.png
// module id = 581
// module chunks = 1